module.exports = __webpack_public_path__ + "static/media/bestquote_logo.197e765f.svg";